var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 9.99998 0C4.47712 0 0 4.47715 0 10C0 15.5228 4.47712 20 9.99998 20Z",
    fill: "#4B27E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.81836C8.38199 1.81836 6.80014 2.29823 5.45465 3.19726C4.10916 4.09629 3.06043 5.3741 2.44117 6.86913C1.82191 8.36416 1.65987 10.0093 1.97557 11.5964C2.29127 13.1835 3.07055 14.6413 4.21479 15.7856C5.35904 16.9298 6.81686 17.7091 8.40398 18.0248C9.99109 18.3405 11.6362 18.1784 13.1312 17.5592C14.6263 16.9399 15.9041 15.8913 16.8031 14.5458C17.7022 13.2003 18.182 11.6184 18.182 10.0002C18.182 7.83022 17.32 5.74915 15.7856 4.21476C14.2512 2.68037 12.1701 1.81836 10.0002 1.81836ZM10.0002 17.6716C8.48283 17.6721 6.9994 17.2225 5.73754 16.3799C4.47568 15.5372 3.49206 14.3392 2.91108 12.9375C2.33009 11.5358 2.17783 9.99324 2.47358 8.50497C2.76933 7.0167 3.49978 5.64956 4.57256 4.57646C5.64534 3.50336 7.01224 2.7725 8.50042 2.47631C9.98859 2.18012 11.5312 2.3319 12.9331 2.91247C14.335 3.49303 15.5333 4.47631 16.3763 5.73793C17.2194 6.99954 17.6693 8.48281 17.6693 10.0002C17.6669 12.0336 16.8582 13.9831 15.4206 15.4212C13.9829 16.8593 12.0336 17.6686 10.0002 17.6716V17.6716Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18164 13.5986V6.40065C8.18164 6.38468 8.19944 6.37515 8.21273 6.38401L13.6112 9.983C13.6231 9.99092 13.6231 10.0084 13.6112 10.0163L8.21273 13.6153C8.19944 13.6241 8.18164 13.6146 8.18164 13.5986Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c2cac669.svg";
export { ForwardRef as ReactComponent };